import styled from "styled-components";
import bgImage from "../../assets/images/logo-bg.png";
import { Link } from "react-router-dom";

export const Container = styled.section`
  height: 100%;
  width: 100%;
  background: url(${bgImage}) no-repeat center center / cover;
  display: flex;
  align-items: center;
  justify-content: right;
  padding-right: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    padding-right: unset;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
  padding: 2rem;
  background: white;
  border-radius: 8px;

  @media (max-width: 768px) {
    height: 100%;
    margin-top: 10rem;
  }
`;

export const Title = styled.h5`
  margin: 1.5rem 0;
  text-align: center;
  font-size: 1.25rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.secondary};
`;

export const Label = styled.label`
  font-weight: 600;
  display: block;
  margin-bottom: 0.25rem;
  color: ${({ theme }) => theme.colors.secondary};
`;

export const Input = styled.input`
  width: 100%;
  height: 40px;
  margin-top: 0.5rem;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  outline: none;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const CheckboxRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 1rem 0;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #555;
`;

export const SubmitButton = styled.button`
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  width: 100%;
  padding: 0.5rem 1rem;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 1rem;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const FooterText = styled.div`
  text-align: center;
  color: #888;
  font-size: 0.9rem;
`;

export const StrongLink = styled(Link)`
  font-weight: bold;
  color: black;

  &:hover {
    text-decoration: underline;
  }
`;

export const FooterWrapper = styled.footer`
  margin-top: auto;
  padding: ${({ theme }) => theme.spacing.md};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.text};

  @media (max-width: 768px) {
    align-content: flex-end;
    margin-top: unset;
    height: 50%;
  }
`;

export const ErrorText = styled.p`
  color: ${({ theme }) => theme.colors.error};
  font-size: 0.875rem;
  font-weight: bold;
  margin-top: ${({ theme }) => theme.spacing.xs};
`;
